import service from './api.services';

const listarAssinaturas = async (idTermoCompromisso) => {
    const response = await service.get(`/api/termo-compromisso/${idTermoCompromisso}`);
    return response.data;
};
const assinarTermo = async (assinaturaDTO, idProcesso) => {
    const response = await service.put(`api/termo-compromisso/assinar/${idProcesso}`, assinaturaDTO);
    return response.data;
};

const registrarAcessoTermo = async (idProcesso) => {
    const response = await service.put(`api/termo-compromisso/registrar-acesso/${idProcesso}`);
    return response.data;
};

const validarTermoCompromisso = async (tipoNumero, numeroDocumento) => {
    const response = await service.get(`/api/public/termo-compromisso/validar/${tipoNumero}/${numeroDocumento}`);
    return response.data;
};


export {
    listarAssinaturas,
    assinarTermo,
    validarTermoCompromisso,
    registrarAcessoTermo
};
